import BasePresenter from '@src/js/separate-logic/base-presenter';
import { external } from '@src/js/separate-logic/decorate/external';
import { dispatchProps } from '@src/js/separate-logic/decorate/dispatchProps';
import { PPTEditorStateType } from '@src/slide/domain/ui-model/constant/edit-state-type';
import { IEditorAppServices } from '@src/slide/application/entry/toc/editor/base/base-editor-app-service.interface';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { IUserPriviledgeService } from '@src/slide/application/service/user-priviledge-service/user-priviledge-service.interface';
import { IMediaManager } from '@src/slide/application/service/media-manager/media-manager.interface';
import { AppEntryType } from '@src/slide/infrastructure/entry/base/infrastructure-base.interface';
import { IPcEditorAppServices } from '@src/slide/application/entry/toc/editor/pc/pc-editor-app-services.interface';
import { IAddonHandler } from '@src/slide/application/service/addon/addon-handler.interface';
import { MenuManagerEventsKeys } from '@src/slide/application/service/menu-manager/menu-manager-events.interface';

export default class ImageElementPresenter extends BasePresenter {
    public componentDidUpdate(): void {
        if (!this.props.fromScale) {
            this.props.onElementUpdate?.();
        }
    }

    public componentWillUpdate(nextProps, nextModel): void {
        // eslint-disable-next-line no-param-reassign
        nextModel.isEditMode = this.getAppServices().viewableServiceLayer.mediaManager.isEditMode;
    }

    @dispatchProps()
    public handleMouseEnter = () => {
        if (this.props.component.selected) {
            this.getAppServices().editableServiceLayer?.menuManager.event
                .emit(MenuManagerEventsKeys.ENTER_ELEMENT, this.props.component.key);
        }
    };

    @dispatchProps()
    public handleMouseLeave = () => {
        if (this.props.component.selected) {
            this.getAppServices().editableServiceLayer?.menuManager.event
                .emit(MenuManagerEventsKeys.LEAVE_ELEMENT, this.props.component.key);
        }
    };

    @dispatchProps()
    public handleDblClick = (e) => {
        if (this.getUserPriviledgeService().pptEditorState === PPTEditorStateType.EDITABLE) {
            e?.stopPropagation();

            const { component: { props } } = this.props;
            // 获取插件类型、插件id
            const { type: addonType, aid: addonAid } = props.addon || {};
            // 获取点击的当前插件快速工具栏的内容
            const manager = this.getAppServices().viewableServiceLayer.addonManager;
            const addonQuickItems = (manager?.addonHandler as IAddonHandler)?.addonQuickItemsMap?.get(addonAid) || ['editAddon'];

            if (addonType === 'latex' && addonQuickItems && addonQuickItems.indexOf('editAddon') !== -1) {
                // 当编辑公式按钮可用时，双击公式调用编辑公式功能
                if (this.getAppServices().getEntryType() === AppEntryType.PC_EDIT) {
                    (this.getAppServices() as IPcEditorAppServices)
                        .editableServiceLayer?.rightSideBarManager.setIsPropertyEditorShown(false);
                }
                // todo: 这行方法看起来可以删除
                this.getAppServices().editableServiceLayer?.menuManager.actionReplaceLatex();
            } else {
                if (this.getAppServices().getEntryType() === AppEntryType.PC_EDIT) {
                    // 按理说只有 gif 会走到这里
                    this.showPicturePreview();
                }
            }

            this.getAppServices().viewableServiceLayer.rightSideBarService.hide();
        } else {
            this.showPicturePreview();
        }
    };

    @dispatchProps()
    public handleClick = () => {
        const { component } = this.props;

        if (component.currentEditState !== PPTEditorStateType.EDITABLE) {
            const linkData = component.props.link;
            const data = linkData ? linkData.href : null;
            const href = data ? this.getAppServices().viewableServiceLayer
                .linkManager.getLinkUrlWithData(data) : undefined;
            if (href) {
                this.getAppServices().editableServiceLayer?.menuManager.event
                    .emit(MenuManagerEventsKeys.LINK_CLICK, component.key);
            }
        }
    };

    @dispatchProps()
    public handleTouchStart = () => {
    };

    @external()
    public getCloneDom = () => {
        const elementContainer = this.getChildRef('elementContainerRef').cloneNode(false);
        elementContainer.appendChild(this.getChildRef('backgroundRef').getCloneDom());
        elementContainer.appendChild(this.getChildRef('foregroundRef').getCloneDom());
        return [
            elementContainer,
        ];
    };

    @dispatchProps()
    public getMediaManager(): IMediaManager | undefined {
        return (AppServiceProvider.getInstance().getAppServices() as IEditorAppServices)
            .viewableServiceLayer.mediaManager;
    }

    private showPicturePreview = () => {
        const { component } = this.props;
        const { viewableServiceLayer } = AppServiceProvider.getInstance().getAppServices() as IPcEditorAppServices;
        viewableServiceLayer?.imagePreviewService?.promise().then(service => service.showPreview(component));
    };

    private hideMediaElement = () => {
        this.setModel({
            shouldRenderMedia: false,
        });
    };

    private getAppServices(): IEditorAppServices {
        return AppServiceProvider.getInstance().getAppServices() as
            IEditorAppServices;
    }

    private getUserPriviledgeService(): IUserPriviledgeService {
        return this.getAppServices().viewableServiceLayer.userPriviledgeService;
    }
}
